import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SetMealIcon(props: IconProps) {
    return <Icon {...props} iconKey={"set_meal"}/>
}
